module.exports = __webpack_public_path__ + "static/media/2020_Scene_CA_ChTradi_RTPlus_280_HD_01.17e94375.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2020_Scene_CA_ChTradi_RTPlus_280_HD_01.png
// module id = 1148
// module chunks = 0